import { useEffect, useState } from 'react';
/** `matchMedia` alapú töréspont figyelés – SSR/bundler alatt inicializálás után áll be. */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => typeof window !== 'undefined' ? window.matchMedia(query).matches : false);
    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);
        listener();
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, [query]);
    return matches;
}
